import * as c from '@chakra-ui/react'
import { TranslateOptions, translateText } from 'src/utils/translateText'

interface VideoProps {
  videoBanner: {
    title: TranslateOptions
    subtitle: TranslateOptions
    text: TranslateOptions
    cta: {
      text: TranslateOptions
      url: string
    }
    videoUrl: string
    idSection?: string
  }
}

export default function Video({ videoBanner }: VideoProps) {
  const [isMobile] = c.useMediaQuery('(max-width: 720px)')

  return (
    <c.Container px={['s5', 0]} id={videoBanner?.idSection}>
      <c.Flex
        borderRadius="20px"
        direction={['column', 'row']}
        justify="space-between"
        gap={['m4', 'l2']}
      >
        <c.Flex w={['full', '360px']} direction="column" gap="s5">
          <c.Heading maxW="225px" size="md">
            {translateText(videoBanner?.title)}
          </c.Heading>
          <c.Text fontSize="t-md.0">
            {translateText(videoBanner?.subtitle)}
          </c.Text>
          <c.Text color="black.400" fontSize="t-sm.0">
            {translateText(videoBanner?.text)}
          </c.Text>

          <c.Button
            as={c.Link}
            isExternal
            href={videoBanner?.cta?.url}
            variant="primary"
            maxW="fit-content"
            borderRadius="full"
            mt={['s3', 's5']}
          >
            {translateText(videoBanner?.cta?.text)}
          </c.Button>
        </c.Flex>

        <c.Box
          borderRadius="20px"
          w={['full', '808px']}
          h={['188px', '390px']}
          overflow="hidden"
        >
          <iframe
            width={isMobile ? '100%' : '808'}
            height={isMobile ? '188' : '456'}
            src={videoBanner?.videoUrl}
            title="YouTube video player"
            allow="autoplay;  encrypted-media;  picture-in-picture; "
            allowFullScreen
          ></iframe>
        </c.Box>
      </c.Flex>
    </c.Container>
  )
}
